module.exports = __webpack_public_path__ + "5b59021d661cb2fc0e9da72d4cfa0484.svg";